export const DISCORD_BOT_CLIENT_ID = '1450060292716494940'

export const DISCORD_INVITE_URL = 'https://discord.gg/sH2UqNu2e'
export const DISCORD_INVITE_URL_ = 'https://honeypot.riskymh.dev/support'
export const DISCORD_SERVER_URL = 'https://discord.com/servers/riskys-server-894705593087049729'
// export const DISCORD_SERVER_URL = DISCORD_INVITE_URL_ // discord discoverability requirements are harsh with retention
export const DISCORD_BOT_INVITE_URL = `https://discord.com/oauth2/authorize?client_id=${DISCORD_BOT_CLIENT_ID}`
export const DISCORD_APP_DIRECTORY_URL = `https://discord.com/discovery/applications/${DISCORD_BOT_CLIENT_ID}`

export const GITHUB_REPO_URL = 'https://github.com/RiskyMH/honeypot'
export const GITHUB_PROFILE_URL = 'https://github.com/RiskyMH'

export const OWNER_URL = 'https://riskymh.dev'
export const APP_URL = 'https://honeypot.riskymh.dev'
export const STATS_URL = 'https://honeypot-stats.riskymh.dev'

export const BOT_LISTING_LINKS = [
  { label: 'Top.gg', href: `https://top.gg/bot/${DISCORD_BOT_CLIENT_ID}` },
  { label: 'Discord Bots', href: `https://discord.bots.gg/bots/${DISCORD_BOT_CLIENT_ID}` },
  { label: 'Discords.com', href: `https://discords.com/bots/bot/${DISCORD_BOT_CLIENT_ID}` },
  { label: 'Discord Bot List', href: 'https://discordbotlist.com/bots/honeypot' },
  { label: 'Discord App Directory', href: DISCORD_APP_DIRECTORY_URL },
  { label: 'Discord Watch', href: `https://discord.watch/applications/${DISCORD_BOT_CLIENT_ID}` },
]
